import { CallAPI } from "../../apiManager/ApiCall";
import { universitiesURL, getProfsForDropdownURL } from "apiManager/APIConfig";

// GET /api/universities/profs — list profs for dropdown (admin: all profs, university_admin: profs in their university)
export const GetProfsForDropdownCall = async () => {
  try {
    const response = await CallAPI({
      url: getProfsForDropdownURL,
      method: "GET",
    });
    return response?.data ?? response?.rows ?? (Array.isArray(response) ? response : []);
  } catch (error) {
    console.error("GetProfsForDropdownCall error", error);
    return [];
  }
};

// GET /api/universities/:university_id/profs — get professors for a university
export const GetUniversityProfsCall = async (universityId) => {
  if (!universityId) return [];
  try {
    const response = await CallAPI({
      url: `${universitiesURL}/${universityId}/profs`,
      method: "GET",
    });
    return response?.data ?? response?.rows ?? (Array.isArray(response) ? response : []);
  } catch (error) {
    console.error("GetUniversityProfsCall error", error);
    return [];
  }
};

// Alias for same endpoint (used when a single university context)
export const GetProfessorsCall = async (universityId = null) => {
  if (!universityId) return [];
  return GetUniversityProfsCall(universityId);
};
